<template>
    <div class="futureCityDescriptionContent">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">昌平自贸组团</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center1 fcd_blockContent2Center3">
          <div class="fcd_blockTitle">一、自贸组团规划</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自贸试验区昌平组团，隶属于中国（北京）自贸试验区科技创新片区。包含生命科学园一、二、三期面积约4.85平方公里，朱辛庄-七里渠区域面积约2.7平方公里，巩华城区域面积约2.2平方公里，其他道路、绿地等公共空间面积约0.51平方公里。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2023年，自贸组团现有企业13478家，外资企业187家，国家高新技术企业251家，上市企业11家。重点发展新一代信息技术、生物与健康、科技服务等产业。</p>
          </div>
          <div class="fcd_blockTitle">二、自贸试验区开放政策</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京自贸试验区聚焦科技创新、服务业开放、数字经济等方面提出110余项开放创新政策措施，其中全国首创政策30余项。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其中，科技创新相关人才服务、知识产权、创新创业生态20余项措施。服务业开放相关金融领域、文化消费、航空服务40余项措施。数字经济相关数字贸易、新业态新模式、国际信息产业近20项措施。医药健康相关医药、医疗器械、医疗服务10余项措施。</p>
          </div>
          <div class="fcd_blockTitle">三、创新资源</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昌平自贸组团聚集了昌平实验室、北京生命科学研究所、北京脑科学与类脑研究中心、国家蛋白质科学中心等10余家高水平研发机构；汇集了王晓东、谢晓亮、施一公等一批战略科学家和300多名高层次人才，入驻了诺华制药、百济神州、诺诚健华等900多家创新型企业，拥有北大国际、清华长庚、北大六院等一批临床医疗服务机构。在新药研制、医疗器械、精准医疗服务等细分领域优势明显，形成了基础研究、中试研发、生产流通、终端医疗的全产业链资源聚集。昌平自贸组团聚集了昌平实验室、北京生命科学研究所、北京脑科学与类脑研究中心、国家蛋白质科学中心等10余家高水平研发机构；汇集了王晓东、谢晓亮、施一公等一批战略科学家和300多名高层次人才，入驻了诺华制药、百济神州、诺诚健华等900多家创新型企业，拥有北大国际、清华长庚、北大六院等一批临床医疗服务机构。在新药研制、医疗器械、精准医疗服务等细分领域优势明显，形成了基础研究、中试研发、生产流通、终端医疗的全产业链资源聚集。</p>
          </div>
          <div class="fcd_blockTitle">四、成果转化</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命谷瞄准医药健康产业发展趋势，聚焦药物发现、实验动物、CRO/CDMO等重点环节累计搭建各类共享服务平台36个，其中，全国首家国际研究型医院落成启用，全市首个细胞与基因治疗领域CDMO平台建成投用。引入新生巢、飞镖等标杆孵化器，建设全国首家数字医疗加速器，孵化落地了优脑银河、北启生物、健达九州等99家知名科学家创办企业。</p>
          </div>
          <div class="fcd_blockTitle">五、产业聚集-生物医药</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医药健康产业是成长性最好、科技含量最高的产业。我们围绕前沿技术、医疗器械、美丽健康三条赛道持续发力。2023年全区医药健康产业实现收入910亿元，增长1.6%。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年我们制定了《医药健康产业倍增行动计划》。2023年出台了《中国（北京）自贸试验区科技创新片区昌平组团促进医药健康产业发展支持办法》。昌平生命科学创新走廊以生命园为核心，以京新、京藏高速为主轴，一直向北延伸。未来3-5年可新供应医药健康产业空间约450万平方米。目前，生命园一二期已建成，三期正在筹建中，总用地面积约4.7平方公里，建筑规模313万平方米，产业空间110万平方米。</p>
          </div>
          <div class="fcd_blockTitle">六、产业聚集-医疗器械</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医疗器械产业近五年年均复合增速超过 25%，在医疗设备、高值耗材、体外诊断等领域集聚了大量龙头企业，上市医疗器械企业9家。企业研发强度保持在11%左右，累计获批创新医疗器械产品22个，占全国12%、全市43%。为进一步明确发展战略目标、重点方向与主要任务，制定《昌平区医疗器械产业提升行动计划 (2023-2025)》。2023年4月印发实施《昌平区医疗器械产业提升行动计划（2023-2025年）》。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;到2025年，昌平区医疗器械产值规模将超过300亿元，全口径收入达到400亿元，医疗器械高新技术企业数量达到200家，专精特新企业数量达到50家，三类医疗器械数量达到200个，全力打造标志性产业链2-3条，新增产业用地面积800亩。生命科学园等重点载体高端产业聚集能力明显增强。</p>
          </div>
          <div class="fcd_blockTitle">七、产业聚集-美丽健康</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年5月发布《北京市昌平区支持美丽健康产业高质量发展若干措施》，2023年北京市经信局和昌平区政府联合印发《北京市美丽健康产业高质量发展三年行动方案》。立足打造“未来美城”，昌平区规划了“一核、三园”的空间格局。其中，“一核”为美丽健康产业科创“核心区”，依托中关村生命科学园，规划建筑规模591万平方米。“三园”为小汤山美丽智造园（257公顷）、小汤山美妆创新园（98.8公顷）。</p>
          </div>
          <div class="fcd_blockTitle">八、产业聚集-合成生物制造</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年1月发布《昌平区支持合成生物制造产业高质量发展的若干措施(试行)》。1月6日，北京市合成生物制造技术创新中心（15万平方米）和中关村合成生物制造产业集聚区起步区正式揭牌。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中关村合成生物制造产业集聚区以“U”字型进行空间布局，有效衔接医药健康、先进能源、先进制造三大主导产业，更好地服务北京未来产业布局，引领区域高质量发展。</p>
          </div>
          <div class="fcd_blockTitle">九、产业聚集-先进制造</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们制定实施了《先进制造产业跃升行动计划》，发布《促进先进制造业发展暂行办法》。成为北京市唯一获评全国中小企业数字化转型试点城市。培育了三一和福田康明斯两家全球“灯塔工厂”，小米智能工厂二期落成投产，紫光数字经济科技园实现开工建设。机器人产业园（“一南一北”机器人赛道聚集区）已于3月开工建设。</p>
          </div>
          <div class="fcd_blockTitle">十、创新成果</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经过多年培育，昌平自贸组团已经进入创新成果的爆发期，涌现出细胞焦亡抗肿瘤免疫功能重大发现、高精度个性化脑功能剖分技术等一批具有世界影响力的原创成果。百济神州“泽布替尼”、诺诚健华“奥布替尼”等一批中国原创新药走向世界，博雅辑因基因编辑药物、数坤科技心血管AI诊断软件等一批全球全国首创产品陆续推出。支持各类创新主体研发攻关，万泰鼻喷式新冠疫苗获批紧急使用；华辉安健广谱抗新冠药物HH-120进入临床Ш期；科兴生物与国家实验室合作开发的新冠广谱中和抗体药物获批临床。</p>
          </div>
          <div class="fcd_blockTitle">十一、创新案例</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;飞镖、高博、医疗器械站、昌生驿站、人遗专员</p>
          </div>
          <div class="fcd_blockTitle">十二、品牌影响</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园荣获首批“中关村特色产业园”</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园被工信部认定为中小企业特色产业集群。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园被认定为国家海外人才离岸创新创业基地。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园获评2023“未来可持续投资”优秀案例</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园医药科技中心项目拿下国家优质工程奖</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园创投基金荣获“源头·启明”投资机构奖TOP20.</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;生命科学园获评“第八届医疗健康投资卓越榜”年度医疗健康产业园区。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2023北京·昌平生命科学国际论坛于11月17日-19日举办，本届论坛以“探索生命 共创未来”为主题，论坛特别邀请了诺贝尔化学奖获得者迈克尔·莱维特先生以及欧美院士专家等国际重磅嘉宾参加。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年2月29日，《Nature》主刊刊登题为《The upward trajectory of China’s ‘Silicon Valley’ for the life sciences》文章，对昌平“生命谷”进行了整版报道。</p>
          </div>
          <div class="fcd_blockTitle">十三、发展环境</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;已搭建自贸昌平组团“一站一室一厅一平台一中心”公共服务体系（昌生驿站、国际人才活动室、外国人服务大厅、企业集中注册平台、综合行政执法分中心）。推行“管家式”服务，实施 “两区”重点园区（组团）“管家式”企业服务机制，为企业提供常态化、持续性服务。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昌平组团配套设施逐渐完善，地铁昌平线已建成、市郊铁路S2线已开工，生命科学大道完成改造并正式通车；向各类人才新配售配租一批共有产权房、公租房；人大附中昌平学校等“名校名园”建成开学；北京大学国际医院和高博医院为昌平组团提供国际化医疗服务；大型商业综合体超级合生汇开业运营，宜居宜业水平显著增强。</p>
          </div>
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
    import '../../styles/parkDescription.css'
    export default {
      name: 'importantPark',
      data () {
        return {
          
        }
      },
      created() {
        
      },
      methods: {
        
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/parkDescription/freeTradeAgreement.vue